//imports
import React from "react";
import "containers/Tribe/Friends/Home/MyFriends.css"
import MyFriends from "containers/Tribe/Friends/Home/MyFriends"

class FriendsHome extends React.Component {
    render(){
        return (
            <section>
                <MyFriends/>
            </section>
        );
    }
}

export default FriendsHome;